import React from 'react';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const ErrorFallback = ({ onClick }: { onClick: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<Stack alignInline="center" space="space.050">
			<StatusErrorIcon label="" />
			<Text as="strong">{formatMessage(messages.errorMessage)}</Text>
			<Button onClick={onClick} spacing="compact">
				{formatMessage(messages.retryMessage)}
			</Button>
		</Stack>
	);
};
